import { render, staticRenderFns } from "./Adjustments.vue?vue&type=template&id=0a098376&scoped=true"
import script from "./Adjustments.vue?vue&type=script&lang=js"
export * from "./Adjustments.vue?vue&type=script&lang=js"
import style0 from "./Adjustments.vue?vue&type=style&index=0&id=0a098376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a098376",
  null
  
)

export default component.exports